<template>
  <el-form :model="optionData" :rules="optionRules" label-width="100px">
    <el-form-item label="网站昵称" prop="name">
      <el-input style="width: 320px;max-width: 500px;" placeholder="请输入网站昵称..." :minlength="3" :maxlength="20" v-model="optionData.name"></el-input>
    </el-form-item>
    <el-form-item label="网站地址" prop="address" required>
      <el-input
        style="width: 320px; max-width: 600px"
        placeholder="请输入完整网址..."
        v-model="optionData.address"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      optionData: {
        name: "",
        address: "",
      },
      optionRules: {
        name: [{ required: true, message: "请输入网站名", trigger: "blur" }],
        address: [{ required: true, message: "请输入网址", trigger: "blur" }],
      },
    };
  },
  methods: {
    getOption() {
      if (!this.optionData.name.trim()) {
        return "请输入网站名！";
      }
      if (!this.optionData.address.trim()) {
        return "请输入网址！";
      }
      if (!/^(https?:\/\/)/.test(this.optionData.address.trim())) {
        return "请输入正确的网站地址！";
      }
      return JSON.parse(JSON.stringify(this.optionData))
    }
  },
};
</script>
